import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { config } from 'utils/config';
import { callApi } from 'utils/utils';
import FieldDataTable from 'components/Controls/FieldDataTable/FieldDataTable';
import FieldButton from 'components/Controls/FieldButton/FieldButton';

const formatDateTime = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  return new Date(value).toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' });
};

const ResultadoFormularioList = (props) => {
  const { t } = useTranslation(['formulario', 'common']);

  const [formularioResueltos, setFormularioResueltos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props.filters === null || props.filters === undefined) {
      return;
    }

    getFormulariosResueltos();
  }, [props.filters]);

  const getFormulariosResueltos = () => {
    setIsLoading(true);

    const filters = props.filters || {};
    const paramsService = {
      ClaFormulario: filters.ClaFormulario,
      ClaTurno: filters.ClaTurno,
      ClaDepartamento: filters.ClaDepartamento,
      ClaCelda: filters.ClaCelda,
      FechaCapturaInicia: filters.FechaCapturaInicia,
      FechaCapturaFin: filters.FechaCapturaFin,
      EsRequiereRevision: filters.EsRequiereRevision,
    };

    const urlWebService = `${config.UrlApiProject}formulario/getFormulariosResueltos`;

    callApi(urlWebService, 'POST', paramsService, (response) => {
      setFormularioResueltos(response.data.FormularioResueltos);
      setIsLoading(false);
    }, () => {
      setIsLoading(false);
    });
  };

  const fechaCapturaTemplate = (row) => (
    <span>{formatDateTime(row.FechaCaptura)}</span>
  );

  const celdaTemplate = (row) => (
    <span>{`${row.ClaveCelda || ''}${row.ABCMachine !== null && row.ABCMachine !== undefined ? row.ABCMachine : ''}`}</span>
  );

  const flagTemplate = (row) => (
    row.EsRequiereRevision === true ? <i className="fab fa-font-awesome-flag text-warning"></i> : <></>
  );

  const optionsTemplate = (row) => (
    <FieldButton
      label={t('formulario:ViewDetail')}
      className="p-button-secondary"
      onClick={() => props.onViewDetail(row.IdFormularioResuelto)}
    />
  );

  if (props.filters === null || props.filters === undefined) {
    return null;
  }

  if (isLoading) {
    return <Skeleton height="20rem" />;
  }

  return (
    <FieldDataTable value={formularioResueltos} scrollable>
      <Column header={t('common:Date')} body={fechaCapturaTemplate} sortable field="FechaCaptura" headerStyle={{ width: '140px' }} />
      <Column header={t('common:User')} field="NomUsuarioResuelve" sortable headerStyle={{ width: '150px' }} />
      <Column header={t('formulario:Questionnaire')} field="NomFormulario" sortable headerStyle={{ width: '420px' }} />
      <Column header={t('formulario:Shift')} field="NomTurno" sortable headerStyle={{ width: '90px' }} />
      <Column header={t('formulario:Department')} field="NomDepartamento" sortable headerStyle={{ width: '130px' }} />
      <Column header={t('formulario:Cell')} body={celdaTemplate} headerStyle={{ width: '90px' }} />
      <Column header="" body={flagTemplate} headerStyle={{ width: '50px' }} />
      <Column header="" body={optionsTemplate} headerStyle={{ width: '140px' }} />
    </FieldDataTable>
  );
};

export default ResultadoFormularioList;
